import React, {useState} from "react";
import styles, {C} from "../styles";
import {apiJoinWaitlist} from "../api/waitlist";

export default function PseudoWaitlistNotice({email, onJoined}) {
    const [joining, setJoining] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [joined, setJoined] = useState(false);

    async function handleJoin() {
        setJoining(true);
        setError("");
        const data = await apiJoinWaitlist(email);
        if (data.error) {
            setError(data.error);
        } else {
            setMessage(data.message);
            setJoined(true);
            onJoined();
        }
        setJoining(false);
    }

    return (
        <div style={{
            backgroundColor: C.primaryLight,
            border: `1px solid ${C.primary}33`,
            borderRadius: 12,
            padding: 16,
            marginBottom: 16,
        }}>
            <p style={{fontSize: 13, color: C.textMuted, margin: "0 0 12px"}}>
                Nous avons épuisé notre stock de pseudos disponibles. Le gestionnaire du site
                en est informé et traitera votre inscription très rapidement dès que de
                nouveaux pseudos seront disponibles.
            </p>
            {!joined && (
                <button onClick={handleJoin} disabled={joining || !email} style={{...styles.primaryButton, width: "100%"}}>
                    {joining ? "En cours..." : "Rejoindre la liste d'attente"}
                </button>
            )}
            {message && <p style={{color: C.primary, fontSize: 13, marginTop: 10}}>{message}</p>}
            {error && <p style={{color: C.danger, fontSize: 13, marginTop: 10}}>{error}</p>}
        </div>
    );
}
